<div *ngIf="license" class="col-md-10 offset-md-1" style="margin-top: 20px; margin-bottom:70px;">
    <div class="row">
        <h1>{{license.licTitle}}</h1>
        <div class="form-group col-md-12 well">
            <p>{{license.licDesc}}</p>
        </div>
    </div>
    <div class="row NCBOLD-title">
        <div class="col-md-12">
            <h2 class="NCBOLD-blue">Other Information</h2>
        </div>
    </div>
    <div class="row well">
        <div class="form-group col-md-6">
            <b>License Application</b>
            <p><a [attr.href]="license.appURL" target="_blank" class="NCBOLD-link-bold" >{{license.appTitle}}</a></p>
        </div>
        <div class="form-group col-md-3">
            <b>Duration of License</b>
            <p>{{license.duration}}</p>
        </div>
        <div class="form-group col-md-3">
            <b>Authority</b>
            <p>{{license.authority}}</p>
        </div>
        <div class="col-md-6" *ngFor="let enum of getEnums()">
            <b>{{enum.label}}</b> {{getEnumVal(enum.name, license[enum.col])}}
        </div>
        <div *ngIf="license.relLicenses.length > 0" class="form-group col-md-12">
            <br><b>Related Licenses:</b><br>
            <span *ngFor="let relLicense of license.relLicenses"><a class="relLicense" [routerLink]="['/license',relLicense.value]">{{relLicense.display}}</a><br></span>
         </div>
         <div *ngIf="license.reciprocity !='' "class="form-group col-md-12"><br>
            <b>Reciprocity:</b><br>{{license.reciprocity}}                            
        </div>
    </div>
    <p></p> 
    <div class="page-break-inside-avoid">
        <div class="row NCBOLD-title">
            <h2 class="NCBOLD-blue col-md-12">Fees</h2>
        </div>
        <div class="row well" style="text-align: center;">
            <div class="col-sm-2"><b>Application</b><br>{{license.applicationFee | currency}}</div>
            <div class="col-sm-2"><b>New License</b><br>{{license.newLicFee | currency}}</div>
            <div class="col-sm-2"><b>Renewal</b><br>{{license.renewalFee | currency}}</div>
            <div class="col-sm-2"><b>Reciprocity:</b><br>{{license.ricipFee | currency}}</div>
            <div class="col-sm-2"><b>Miscellaneous:</b><br>{{license.miscFee | currency}}</div>
        </div>
    </div> <!-- End of printer by-pass -->
    <p></p>
    <div class="page-break-inside-avoid" *ngIf="license?.otherReq && license.otherReq!==''">
        <div class="row NCBOLD-title">
            <h2 class="NCBOLD-blue col-md-12">Other Requirements</h2>
        </div>
        <div Data class="row well">
            <p class="col-md-12">{{license.otherReq}}</p>
        </div>
    </div> <!-- End of printer by-pass -->
    <div class="page-break-inside-avoid" *ngIf="license?.exemptions && license.exemptions!==''" >
        <h2 class="NCBOLD-blue">Exemptions</h2>
        <div class="row well">
            <div class="col-md-12">
                <div>
                    <p>{{license.exemptions}}</p>
                </div>
            </div>
        </div>
    </div> <!-- End of printer by-pass -->
    <div>
        <div license.licenseURLLabel class="row NCBOLD-title">
            <div class="col-md-12">
                <h2 class="NCBOLD-blue">More Information</h2>
            </div>
        </div>
        <div license.licenseURLBody class="row well">
            <div class="col-md-12">
                <div class="hidden-print">
                    <a href="{{license.licenseURL}}" class="url NCBOLD-link-bold">{{license.licenseURL}}</a>
                </div>
            </div>
        </div>
    </div> <!-- End of printer by-pass -->
    <div class="page-break-inside-avoid">
        <div class="row NCBOLD-title page-break-inside-avoid">
            <div class="col-md-12">
                <p><h2 class="NCBOLD-blue">Licensing Authority</h2>
            </div>
        </div>
        <div class="row well page-break-inside-avoid">
            <div class="col-md-12">
                <div>
                    <p>
                        {{license.department}}<br>
                        <span *ngIf="license.division!=='' ">{{license.division}}<br></span>
                        <span *ngIf="license.board!=='' ">{{license.board}}<br></span>
                        {{license.address1}}<br />
                        <span *ngIf="license.address2 && license.address2!=='' ">{{license.address2}}<br></span>                        
                        {{license.city}},&nbsp;{{license.st}}&nbsp;{{license.zip}}<br />
                        <a href="tel: 1-{{license.authPhone}}p{{license.authExt}}">{{license.authPhone?license.authPhone.substr(0,3)+'-'+
                            license.authPhone.substr(3,3)+'-'+license.authPhone.substr(6):''}}
                            <span *ngIf="license.authExt"> Ext: {{license.authExt}}</span></a><br/>
                        {{license.officeHours}}
                    <div class="visible-print">
                        <a class="url" href="{{license.authURL}}">{{license.authURL}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div> <!--page-break-inside-avoid-->
    <div *ngIf="license.occs && license.occs.length>0" class="page-break-inside-avoid">
        <div class="row NCBOLD-title">
            <div class="col-md-12">
                <p><h2 class="NCBOLD-blue">Occupational Information</h2>
            </div>
        </div>
        <div *ngFor="let o of license.occs" class="row">
            <div class="col-md-12">
                <p>
                <b>{{o.occTitle}}</b><br />
                {{o.occDesc}}<p><p><p><p>
                <a *ngIf="o.hasOccProfile" href="//nccareers.org/occupation-profile/{{o.occCode.substr(0,2)+o.occCode.substr(3,4)}}/1284" target="_blank">Occupational profile</a>
            </div>
        </div>
    </div>
    <div style="text-align:center;">
        Please check with your local City, County or Municipality for area specific license requirements they may have.<p></p>
    </div>
    <pm-footer></pm-footer>
</div>

<div *ngIf="licListPtr>=0" class="fixed-bottom float-left d-print-none">
    <a [routerLink]="['/license',licList[0]]">
        <button class="btn btn-primary btn-ncb-wide" [disabled]="licListPtr===0"><i class="fa fas fa-angle-double-left"></i></button></a>&nbsp;                    
    <a [routerLink]="['/license',licList[math.max(licListPtr-1,0)]]">
        <button class="btn btn-primary btn-ncb-wide" [disabled]="licListPtr===0"><i class="fa fas fa-angle-left"></i></button></a>&nbsp;                   
    {{licListPtr+1}} of {{licList.length}}&nbsp; 
    <a [routerLink]="['/license',licList[math.min(licListPtr+1,licList.length-1)]]">
        <button class="btn btn-primary btn-ncb-wide" [disabled]="licListPtr===licList.length-1"><i class="fa fas fa-angle-right"></i></button></a>&nbsp;                    
    <a [routerLink]="['/license',licList[licList.length-1]]">
        <button class="btn btn-primary btn-ncb-wide" [disabled]="licListPtr===licList.length-1"><i class="fa fas fa-angle-double-right"></i></button></a>&nbsp;
</div>    

